import { Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LeadService } from '../../services/lead.service';
import { catchError, forkJoin, map, merge, Observable, of, startWith, switchMap } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { FormControl, NgForm } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ToastrService } from 'ngx-toastr';
import { CountryISO } from 'ngx-intl-tel-input';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { UsersService } from '../../services/users.service';
import { TrackingService } from '../../services/tracking.service';
import { PipeLineService } from 'src/app/private/services/pipeline.service';
import { TeamService } from 'src/app/private/services/teams.service';
import { PermissionService } from '../../services/permission.service';
import {
  StableLeadFieldDateCache,
  getEffectiveLeadFieldMinDate,
} from 'src/app/utils/lead-field-date.util';
import {
  applyLeadVisibilityToExportPayload,
  applyLeadVisibilityUserId,
} from 'src/app/utils/lead-visibility.util';
import {
  normalizeLeadEditModel,
} from 'src/app/utils/lead-profile-field.util';
import {
  DEFAULT_LEAD_STATUS,
  DEFAULT_LEAD_TYPE,
  normalizeLeadStatus,
  normalizeLeadType,
} from 'src/app/utils/lead-status.util';
import {
  assignIntlPhone,
  formatPhoneImportErrors,
  phoneControlValue,
  phoneImportToastOptions,
  regionForDialCode,
  readImportErrors,
  resolvePhone,
} from 'src/app/utils/phone-country.util';
import {
  applyCrmSourcePipeline,
  findPipelineById,
  isCrmLeadSource,
  pipelineStageLabel,
} from 'src/app/utils/crm-lead-pipeline.util';
import { getLeadStatusBadgeClass } from 'src/app/utils/status-badge.util';
import {
  getLeadSourceImg as resolveLeadSourceImg,
  isLeadSourceImage,
} from 'src/app/utils/lead-source-icon.util';
import {
  getLeadFieldPattern,
  isLinkedInLinkField,
  validateLeadLinkedInFields,
  LINKEDIN_URL_VALIDATION_MESSAGE,
} from 'src/app/utils/lead-link-field.util';
import {
  HEALTHCARE_SECTOR_FIELDS,
  clearHealthcareSectorFieldValues,
  getSectorFieldName,
  isHealthcareSectorValue,
  isLeadSectorField,
} from 'src/app/utils/lead-healthcare-sector.util';

@Component({
  selector: 'app-lead',
  templateUrl: './lead.component.html',
  styleUrls: ['./lead.component.scss'],
})
export class LeadComponent implements OnDestroy {
  getLeadFieldPattern = getLeadFieldPattern;
  isLinkedInLinkField = isLinkedInLinkField;
  linkedInUrlValidationMessage = LINKEDIN_URL_VALIDATION_MESSAGE;
  leadActionMenu: {
    lead: any;
    top: number;
    left: number;
    variant: 'all' | 'space';
  } | null = null;
  actionMenuOpenedAt = 0;
  private readonly onActionMenuScroll = (event?: Event) => {
    if (!this.leadActionMenu) return;
    if (Date.now() - this.actionMenuOpenedAt < 250) return;
    const target = event?.target as HTMLElement | null;
    if (target?.closest && target.closest('.lead-action-menu')) return;
    this.ngZone.run(() => {
      this.leadActionMenu = null;
    });
  };
  currentMobilePopupLeadId: any;
  mobileCreatePopup: boolean = false;
  isCenter: boolean = false;
  btnUpdateLoading: boolean = false;
  center_id: any;
  isLoading = false;
  totalRows = 0;
  pageSize = 25;
  isCron: any;
  isDivVisible = true;
  isReminderChecked: boolean = true;
  btnLoading: boolean = false;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  currentTab = 'all_leads';
  followupLoading = false;
  formAction = 'add';
  closeResult = '';
  isSubmitted: boolean = false;
  displayedColumns: string[] = [
    'select',
    'info',
    'contact_name',
    'lead_source',
    'contact_email',
    'contact_phone',
    'company_name',
    'lead_type',
    'lead_status',
    'action'
  ];
  renderColumns: string[] = [
    'info',
    'contact_name',
    'lead_source',
    'contact_email',
    'contact_phone',
    'company_name',
    'lead_type',
    'lead_status',
    'action'
  ];
  displayedLebel: any = {
    contact_name: 'Contact Name',
    lead_source: 'Source',
    contact_email: 'Contact Email',
    contact_phone: 'Contact Number',
    company_name: 'Organisation',
    lead_type: 'Type',
    lead_status: 'Status'
  };
  exportColumns: string[] = [];
  leadsRecord: any = [];
  infoArray: any = [];
  dateObject: any = { startDate: '', endDate: '' };
  lead: Lead = new Lead();
  leadFolloup: LeadFollowup = new LeadFollowup();
  @ViewChild('leadForm')
  leadForm!: NgForm;
  @ViewChild('editleadForm')
  editleadForm!: NgForm;
  @ViewChild('leadFolloupForm')
  leadFolloupForm!: NgForm;
  leadsFollowList: any = [];
  leadChannels: any = [];
  users: any = [];
  mergedArr: any = [];
  exportArrayData: any = [];
  preUserId: any = '';
  LeadArrayData = [];
  temp: any = [];
  subsciberListName: any = '';
  customer = false;
  allLeadFeilds: any = [];
  filterArray: any = [];
  copyOfFields: any = {};
  deleteParam: any = {};
  isAdmin: any = false;
  exportDataMap: any = {};
  isExportLoading: boolean = false;
  isFixedColumn: boolean = false;
  isGetLocation: boolean = false;
  createFieldFormValue: any = {
    fields: {},
    lead_date: '',
    lead_status:'',
    lead_type:'',
    lead_source:'',
    lead_time: '',
    user_id: '',
    team_id: '',
    isEdit: false
  };
  topPosition: any;
  leftPosition: any;
  hoveredRow: any;
  current_id_hover: any;
  fieldValues: any = {};
  editFieldValues: any = {};
  remarkValue: any = '';
  notification_date: any = '';
  next_action: any = '';
  editShow: boolean = false;
  defaultSort = "updatedAt";
  accessObject: any = {}
  canCreateContactGroup = false;
  uploadBtnLoading: boolean = false;
  leadSpaceToggle: boolean = false;
  leadSpaceList: any = [];
  leadSpaceName: any;
  currentSpace_id: any;
  idToDelete: any;
  idToEdit: any;
  nameLeadSpaceToEdit: any;
  currentActiveTabId: any;
  initialLoad: boolean = false;
  leadToMove: any;
  selectedLeadSpace: any;
  @ViewChild('AllLeadsTab', { static: true })
  AllLeadsTab!: ElementRef;
  defaultFilter: any = [
    'contact_name',
    'lead_source',
    'lead_type',
    'lead_id',
    'lead_status',
    'contact_email',
    'contact_phone',
    'company_name',
    'user_id'

  ];
  communicationData: any;
  leadToConvert: any;
  leadRecords: any = [];
  leadStatusList: any[] = [];
  isReminderMode: boolean = false;

  pipelines = [];
  pipelineData: any = [];
  isSaving: boolean = false;

  importColumnsArray: any = [];
  exportColumnArrayObject: any = [];
  isToggled: boolean = false;

  kanbanStatus: boolean = false;

  bulkLeadFilterData: any = {};
  bulkLeadFilterLoading: boolean = false;
  isBulkLeadFilter: boolean = false;

  todayDate: any = moment().format('YYYY-MM-DD');

  currentSelectedLeadSpaceId: any = null;
  currentSelectedLeadSpaceName: any = null;
  assignToTeam = false;

  teams : any[] = [
];

  // Client IDs for which email should not be mandatory
  emailNotMandatoryClientIds: number[] = [73];

  readonly healthcareSectorFields = HEALTHCARE_SECTOR_FIELDS;

  private leadFieldDateCache = new StableLeadFieldDateCache();

  /** First page from bootstrap (forkJoin) — consumed once by loadData() to avoid a duplicate getLeads. */
  private initialLeadsBootstrapResponse: any = null;
  private consumeInitialLeadsBootstrap = false;
  private sortPageResetBound = false;

  getCreateLeadDateModel(item: any): Date | null {
    return this.leadFieldDateCache.getModel(
      `c:${item.field_name}`,
      this.fieldValues[item.field_name]
    );
  }

  getCreateLeadMinDate(item: any): Date {
    return getEffectiveLeadFieldMinDate(item['min-length']);
  }

  getCreateLeadMaxDate(item: any): Date | undefined {
    const d = this.leadFieldDateCache.getModel(
      `cfg:cmax:${item.field_name}`,
      item['max-length']
    );
    return d ?? undefined;
  }

  getCreateLeadSubDateModel(item: any, subIndex: number, subf: any): Date | null {
    const cellKey = subf.field_name + '|' + subIndex;
    const raw =
      this.fieldValues[item.field_name + '|subf']?.[subIndex]?.[cellKey];
    return this.leadFieldDateCache.getModel(
      `c:${item.field_name}:${subIndex}:${subf.field_name}`,
      raw
    );
  }

  getCreateLeadSubMinDate(subf: any): Date {
    return getEffectiveLeadFieldMinDate(subf['min-length']);
  }

  getCreateLeadSubMaxDate(subf: any): Date | undefined {
    const d = this.leadFieldDateCache.getModel(
      `cfg:csmax:${subf.field_name}`,
      subf['max-length']
    );
    return d ?? undefined;
  }

  getEditLeadDateModel(item: any): Date | null {
    return this.leadFieldDateCache.getModel(
      `e:${item.field_name}`,
      this.editFieldValues['fields']?.[item.field_name]
    );
  }

  getEditLeadMinDate(item: any): Date {
    return getEffectiveLeadFieldMinDate(item['min-length']);
  }

  getEditLeadMaxDate(item: any): Date | undefined {
    const d = this.leadFieldDateCache.getModel(
      `cfg:emax:${item.field_name}`,
      item['max-length']
    );
    return d ?? undefined;
  }

  getEditLeadSubDateModel(item: any, subIndex: number, subf: any): Date | null {
    const fn = this.getValue('field_name', item, subIndex);
    const cellKey = fn + '|' + subIndex;
    const raw =
      this.editFieldValues['fields']?.[item.field_name + '|subf']?.[subIndex]?.[
        cellKey
      ];
    return this.leadFieldDateCache.getModel(
      `e:${item.field_name}:${subIndex}:${fn}`,
      raw
    );
  }

  getEditLeadSubMinDate(item: any, subIndex: number): Date {
    return getEffectiveLeadFieldMinDate(this.getValue('min-length', item, subIndex));
  }

  getEditLeadSubMaxDate(item: any, subIndex: number): Date | undefined {
    const d = this.leadFieldDateCache.getModel(
      `cfg:esmax:${item.field_name}:${subIndex}`,
      this.getValue('max-length', item, subIndex)
    );
    return d ?? undefined;
  }

  setCreateLeadDateField(fieldName: string, d: Date | null) {
    const iso = this.leadFieldDateCache.rememberPick(`c:${fieldName}`, d);
    this.fieldValues[fieldName] = iso || null;
  }

  setCreateLeadSubDate(item: any, subIndex: number, subf: any, d: Date | null) {
    const key = subf.field_name + '|' + subIndex;
    const row = this.fieldValues[item.field_name + '|subf']?.[subIndex];
    if (row) {
      const iso = this.leadFieldDateCache.rememberPick(
        `c:${item.field_name}:${subIndex}:${subf.field_name}`,
        d
      );
      row[key] = iso || null;
    }
  }

  setEditLeadDateField(fieldName: string, d: Date | null) {
    if (!this.editFieldValues['fields']) this.editFieldValues['fields'] = {};
    const iso = this.leadFieldDateCache.rememberPick(`e:${fieldName}`, d);
    this.editFieldValues['fields'][fieldName] = iso || null;
  }

  setEditLeadSubDate(item: any, subIndex: number, subf: any, d: Date | null) {
    const fn = this.getValue('field_name', item, subIndex);
    const cellKey = fn + '|' + subIndex;
    const row = this.editFieldValues['fields'][item.field_name + '|subf']?.[subIndex];
    if (row) {
      const iso = this.leadFieldDateCache.rememberPick(
        `e:${item.field_name}:${subIndex}:${fn}`,
        d
      );
      row[cellKey] = iso || null;
    }
  }

  leadFilters = [
    { name: 'Owner Assigned', checked: false, condition: 'with' },
    { name: 'FollowUp', checked: false, condition: 'with' },
    { name: 'Notes', checked: false, condition: 'with' },
    { name: 'Meeting', checked: false, condition: 'without' },
    { name: 'Task', checked: false, condition: 'with' },
    { name: 'Calls', checked: false, condition: 'with' },
    { name: 'Emails', checked: false, condition: 'with' }
  ];
  @ViewChild('emailConfirm') emailConfirmModal!: TemplateRef<any>;
@ViewChild('navScroll', { static: false }) navScroll!: ElementRef;
@ViewChild('tabScroll', { static: false }) tabScroll!: ElementRef;
  constructor(
    private toast: ToastrService,
    private api: LeadService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private tracker: TrackingService,
    private eRef: ElementRef, private renderer: Renderer2,
    private pipelineApi: PipeLineService,
    private tempapi: TeamService,
    private cdr: ChangeDetectorRef,
    private permissionService: PermissionService,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.isCenter = localStorage.getIsCenter();
    this.isFixedColumn = localStorage.getIsFixedCol();
    this.isGetLocation = localStorage.getIsGetLocation();
    //alert(this.isFixedColumn)
    if (this.isCenter) {
      this.center_id = localStorage.getCenterId();
    }
    this.leadChannels = JSON.parse(
      JSON.stringify(this.localStorage.getLeadChannels())
    );
    this.isCron = this.localStorage.getCron();
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
    // this.tracker.track("View","Leads","User Viewed:Lead Listing",null)
  }

  isMobileView(): boolean {
    return window.innerWidth <= 1024;
  }
  shouldShowPopup(): boolean {
    return this.isMobileView() ? this.mobileCreatePopup : this.leadSpaceToggle;
  }
  closePopup(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    if (this.isMobileView()) {
      this.mobileCreatePopup = false;
    }
    this.leadSpaceToggle = false;
  }

scrollTabs(direction: 'left' | 'right') {
  const el = this.tabScroll?.nativeElement;
  if (!el) {
    return;
  }
  const scrollAmount = 200;

  if (direction === 'left') {
    el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  } else {
    el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
}
  initDynamicFields() {
  this.allLeadFeilds?.forEach((item:any) => {

    // Only for select fields
    if (item.type === 'select') {

      // If no value set yet
      if (
        this.fieldValues[item.field_name] === undefined ||
        this.fieldValues[item.field_name] === null
      ) {
        // ✅ Auto-select first option
        if (item.data && item.data.length > 0) {
          this.fieldValues[item.field_name] = null;
        }
      }
    }
  });
}

  private getLeadFieldsBag(forEdit = false): Record<string, unknown> {
    if (forEdit || this.formAction === 'update') {
      if (!this.editFieldValues.fields) {
        this.editFieldValues.fields = {};
      }
      return this.editFieldValues.fields;
    }
    return this.fieldValues;
  }

  private getSelectedSectorValue(forEdit = false): unknown {
    const sectorFieldName = getSectorFieldName(this.allLeadFeilds);
    if (!sectorFieldName) {
      return null;
    }
    return this.getLeadFieldsBag(forEdit)[sectorFieldName];
  }

  isHealthcareSectorSelected(forEdit = false): boolean {
    return isHealthcareSectorValue(this.getSelectedSectorValue(forEdit));
  }

  onLeadSectorChange(item: any, value: unknown, forEdit = false): void {
    if (!isLeadSectorField(item)) {
      return;
    }
    if (!isHealthcareSectorValue(value)) {
      clearHealthcareSectorFieldValues(this.getLeadFieldsBag(forEdit));
    }
    this.refreshContactEmailValidation(forEdit);
    this.cdr.detectChanges();
  }

  private refreshContactEmailValidation(forEdit = false): void {
    const form = forEdit ? this.editleadForm : this.leadForm;
    form?.controls?.['contact_email']?.updateValueAndValidity();
  }
  handleToggle() {
    this.toggleLeadSpace();
    this.toggleMobileCreatePopup();
  }


  showKanban() {
    this.kanbanStatus = (this.kanbanStatus) ? false : true
  }
  toggleLeadSpace() {
    if (!this.isMobileView()) {
      this.leadSpaceToggle = !this.leadSpaceToggle;
      this.mobileCreatePopup = false;
    } else {
      this.toggleMobileCreatePopup();
    }
  }
  createLeadSpace() {

    this.btnLoading = true;
    if (this.leadSpaceName != "") {
      let param : any = {
        client_id: this.localStorage.getClientId(),
        space_name: this.leadSpaceName
      }

      if(!this.isAdmin){
        param['user_id'] = this.localStorage.getUserId();
      }

      this.api.createLeadSpace(param).subscribe({
        next: (res) => {
          if (res) {
            this.getLeadSpace()
            setTimeout(() => {
              this.leadSpaceName = "";
              this.mobileCreatePopup = false;
              this.leadSpaceToggle = false;
              this.toast.success("Lead Space Created Successfully")
              this.btnLoading = false;
            }, 1000)
            this.closePopup()
          }
        }, error: (e) => {
          this.btnLoading = false;
        }
      })
    }

  }
  private buildLeadSpaceRequestParam(): any {
    let param: any = {
      where: {
        client_id: this.localStorage.getClientId(),
      },
    };
    if (!this.isAdmin) {
      param.where = { ...param.where, user_id: this.localStorage.getUserId() };
    }
    return param;
  }

  getLeadSpace(name: any = null) {
    const param = this.buildLeadSpaceRequestParam();

    this.api.getAllLeadSpace(param).subscribe({
      next: (res) => {
        if (res) {
          this.leadSpaceList = res;

          if (name) {
            this.currentTab = name;
          }
        }
      }, error: (e) => {
      }
    })
  }
  ngAfterViewInit() {
    //console.log('sdf');
    this.dataSource.sort = this.sort;
    /* Server-side pagination: do not attach paginator to MatTableDataSource — it would slice the
       current page of rows again when pageIndex > 0 (breaks lead space tabs after reloadData). */

    this.currentTab = 'all_leads';
    this.bootstrapLeadModule();
  }


    getAllTeams() {
    const payload = { "client_id": this.localStorage.getClientId() };
    this.tempapi.getAllTeams(payload).subscribe(
      (res: any) => {
        this.teams = res;
        
      },
      (err: any) => {
        console.error(err);
      }
    )
  }

  // Track function for lead space list to improve performance
  trackBySpaceId(index: number, space: any): any {
    return space.id;
  }

  // Handle sort changes
  onSortChange(sortEvent: any) {
    console.log('Sort changed:', sortEvent);
    this.sort.active = sortEvent.active;
    this.reloadData();
  }
  ngOnInit(): void {
    // Use PermissionService to check feature access
    this.accessObject = this.permissionService.getAccessObject('lead')
    this.canCreateContactGroup = this.permissionService.hasModuleAccess('campaign');
    //console.log(" accessObj", this.permissionService.getAccessObject('lead'))
    this.getAllUsers();
    this.getAllPipeline();
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('scroll', this.onActionMenuScroll, true);
    });
  }

  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.onActionMenuScroll, true);
  }

  openLeadActionMenu(event: MouseEvent, lead: any, variant: 'all' | 'space'): void {
    event.preventDefault();
    event.stopPropagation();
    const sameLead =
      this.leadActionMenu?.lead?.lead_id === lead?.lead_id &&
      this.leadActionMenu?.variant === variant;
    if (sameLead) {
      this.leadActionMenu = null;
      return;
    }
    this.actionMenuOpenedAt = Date.now();
    const trigger = (event.currentTarget as HTMLElement) || (event.target as HTMLElement);
    const rect = trigger.getBoundingClientRect();
    const menuWidth = 210;
    const menuHeight = this.leadActionMenuHeight(variant, lead);
    const { top, left } = this.leadActionMenuPosition(rect, menuWidth, menuHeight);
    this.leadActionMenu = { lead, top, left, variant };
    this.placeLeadActionMenu(rect, lead);
  }

  canShowAction(actionKey: string, lead?: any, variant?: 'all' | 'space'): boolean {
    const access = this.accessObject || {};
    // When access object is empty ({}) = RBAC not configured yet → show all items.
    const unconfigured = Object.keys(access).length === 0;
    if (unconfigured) return true;

    switch (actionKey) {
      case 'edit':
        return !!access.update || lead?.isEdit == 'true' || lead?.isEdit === true;
      case 'view_profile':
        return !!access.lead_profile_view;
      case 'communication':
        return !!access.communication;
      case 'activity_logs':
        return variant === 'all'
          ? !!access.lead_activity
          : !!access.communication;
      case 'follow_up':
        return variant === 'space' || !!access.follow_up;
      case 'task':
        return !!access.task;
      case 'meeting':
        return !!access.meetings;
      case 'notes':
        return !!access.notes;
      case 'lead_space':
        return variant === 'space' || !!access.tabs;
      case 'convert_account':
        return !!access.convert_account;
      case 'delete':
        return this.isAdmin || !!access.delete;
      default:
        return true;
    }
  }

  private leadActionMenuPosition(
    rect: DOMRect,
    width: number,
    height: number,
  ): { top: number; left: number } {
    const viewWidth = window.innerWidth;
    const viewHeight = window.innerHeight;

    let top = rect.bottom + 4;
    if (top + height > viewHeight - 8) {
      top = rect.top - height - 4;
    }
    if (top < 8) top = 8;

    let left = rect.right - width;
    if (left < 8) left = 8;
    if (left + width > viewWidth - 8) {
      left = Math.max(8, viewWidth - width - 8);
    }
    return { top, left };
  }

  private leadActionMenuHeight(variant: 'all' | 'space', lead: any): number {
    let count = 0;
    const actions = [
      'edit',
      'view_profile',
      'communication',
      'activity_logs',
      'follow_up',
      'task',
      'meeting',
      'notes',
      'lead_space',
      'convert_account',
      'delete',
    ];
    for (const a of actions) {
      if (this.canShowAction(a, lead, variant)) count++;
    }
    return Math.max(count, 1) * 36 + 14;
  }

  private placeLeadActionMenu(rect: DOMRect, lead: any): void {
    requestAnimationFrame(() => {
      const menu = document.querySelector('.lead-action-menu') as HTMLElement | null;
      if (!menu || this.leadActionMenu?.lead !== lead) return;
      const height = menu.offsetHeight;
      const width = menu.offsetWidth || 210;
      const { top, left } = this.leadActionMenuPosition(rect, width, height);
      const current = this.leadActionMenu;
      if (!current) return;
      if (Math.abs(current.top - top) < 2 && Math.abs(current.left - left) < 2) return;
      this.ngZone.run(() => {
        if (!this.leadActionMenu || this.leadActionMenu.lead !== lead) return;
        this.leadActionMenu = { ...this.leadActionMenu, top, left };
      });
    });
  }

  closeLeadActionMenu(): void {
    this.leadActionMenu = null;
  }

  @HostListener('document:click', ['$event'])
  closeLeadActionMenuFromDocument(event: MouseEvent): void {
    if (!this.leadActionMenu) return;
    if (Date.now() - this.actionMenuOpenedAt < 150) return;
    const target = event.target as HTMLElement | null;
    if (target?.closest('.lead-action-menu, .actionimg, .btn-lead-action-trigger')) return;
    this.leadActionMenu = null;
  }
  // deleteOpen(id:any) {
  //  this.currentSpace_id =  id;
  // }

  onClickedOutside() {
    console.log('Clicked outside the element!');
    // Handle the click outside event
  }
  hideSubFields(item: any) {
    // console.log(item)
    if (item.includes('subf'))
      return false
    else
      return true
  }
  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const data = <any[][]>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      // console.log(data);
    };
    reader.readAsBinaryString(target.files[0]);
  }
  isValidEmail(email: string, form?: any, key?: any): boolean {
    if (!email) {
      return true;
    }
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Method to check if email should be mandatory for current client
  isEmailMandatory(): boolean {
    const currentClientId = parseInt(this.localStorage.getClientId(), 10);
    if (this.emailNotMandatoryClientIds.includes(currentClientId)) {
      return false;
    }
    if (this.isHealthcareSectorSelected(this.formAction === 'update')) {
      return false;
    }
    return true;
  }

  scrollTableTo(direction: any) {
    const el: any = document.querySelector('.table-container');
    if (direction === 'right') {
      el?.scrollBy({
        left: el.offsetWidth,
        behavior: 'smooth',
      });
    } else if (direction === 'left') {
      el?.scrollBy({
        left: -el.offsetWidth,
        behavior: 'smooth',
      });
    }
  }

  addMoreSubField(id: any, item: any) {
    console.log(item);
    let inc = item.sub_fields?.length;
    const add = this.copyOfFields?.[item.field_name];

    // item.sub_fields.forEach((element: any) => {
    //   this.fieldValues[item.field_name + '|subf'].push({
    //     [element.field_name + '|' + inc]: '',
    //   });
    //   inc++;
    // });
    // this.allLeadFeilds[id].sub_fields.push(
    //   ...this.allLeadFeilds[id].sub_fields
    // );
    for (let i = 0; i < add; i++) {
      this.fieldValues[item.field_name + '|subf'].push({
        [item.sub_fields[i].field_name + '|' + inc]: '',
      });
      inc++;
    }
    this.allLeadFeilds[id].sub_fields.push(
      ...this.allLeadFeilds[id].sub_fields.slice(0, add)
    );
  }
  updateStatus(event: any) {
    this.isSaving = true;
    this.api.updateLead(event).subscribe({
      next: (c) => {
        this.isSaving = false;

      },
      error: (e) => {
        this.btnLoading = false;
        this.isSaving = false;
        this.isSubmitted = false;
      },
      complete: () => { },
    });
  }

  // console.log(this.lead)

  removeSubField(id: any, item: any, subInd: any) {
    const popLen = this.copyOfFields[item.field_name];
    this.fieldValues[item.field_name + '|subf'].splice(subInd, popLen);
    this.allLeadFeilds[id].sub_fields.splice(subInd, popLen);

    let inc = 0;
    this.fieldValues[item.field_name + '|subf'].forEach((element: any) => {
      const val = element;
      const preKey = Object.keys(element)[0];
      const preKeyVal = preKey.split('|');
      this.fieldValues[item.field_name + '|subf'][inc] = {
        [preKeyVal[0] + '|' + inc]: val[preKey],
      };
      inc++;
    });
  }

  getEditButton(id: any) {
    if (
      this.localStorage.checkFullAccessForTableList(this.localStorage.getRole())
    ) {
      return true;
    } else {
      if (id == this.localStorage.getUserId()) {
        return true;
      } else {
        return false;
      }
    }
  }

  handleStoreCurrentSpaceId(id: any, open: boolean = false) {
    this.previousTab = id;
    if (this.currentActiveTabId == id) {
      this.currentSpace_id = null;
      this.cdr.detectChanges();
      return
    }
    // male data empty
    this.dataSource.data = [];
    this.currentActiveTabId = id;
    this.isDataLoading = true;
    this.paginator.pageIndex = 0;
    this.reloadData();

    if (!open) {
      this.currentSpace_id = null;
    } else {
      this.currentSpace_id = id;
    }
    this.cdr.detectChanges();

  }
  //get all user
  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  // open the model to convert lead to account
  handleOpenConvertAccountModel(content: any, element: any) {
    this.leadToConvert = element;
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true, backdrop: 'static', keyboard: false
    });
  }

  // get value
  getValue(value: any, item: any, subInd: any) {
    let subflen = item.sub_fields.length;
    let accessIndex = subInd % subflen;
    return item.sub_fields[accessIndex][value];
  }

  //getARYA
  getArray(item: any) {
    return this.editFieldValues['fields'][item.field_name + '|subf'];
  }

  private applyLeadsRowsToTable(data: any): void {
    const rows = Array.isArray(data?.rows) ? data.rows : [];
    rows.forEach((e: any, i: any) => {
      const index = this.temp.findIndex((p: any) => {
        if (p.lead_id === e.lead_id) {
          rows[i].isSelected = true;
        }
      });
    });
    this.dataSource = new MatTableDataSource<any>(rows);
    this.dataSource.paginator = null;
    this.leadRecords = rows;
    this.initialLoad = false;
    this.isDataLoading = false;
    this.bulkLeadFilterLoading = false;
  }

  /** Same request shape as loadData / reloadData (non-streaming). */
  private fetchLeadsListPage$(): Observable<any> {
    let param: any = {
      where: this.buildGetAllLeadsBaseWhere(),
      filter: {},
      page: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      order: {
        col: this.sort?.active == 'lead_date' ? 'lead_date' : this.sort?.active == 'lead_time' ? 'lead_time' : this.sort?.active == 'lead_type' ? 'lead_type' : this.sort?.active == 'lead_status' ? 'lead_status' : this.sort?.active == undefined ? 'updatedAt' : this.sort?.active,
        dir: this.sort?.direction || 'DESC',
      },
    };

    if (this.currentActiveTabId) {
      param.where = { ...param.where, lead_space_id: this.currentActiveTabId };
    }
    this.mergeLeadListDateQuery(param);
    this.applyLeadListVisibility(param);
    this.mergeAllowedSearchIntoFilter(param);
    this.applyLeadSearchFilters(param);

    if (this.isBulkLeadFilter) {
      const payload: any = {
        advanced_filters: this.bulkLeadFilterData,
        client_id: this.localStorage.getClientId(),
        center_id: this.localStorage.getCenterId(),
        page: this.paginator.pageIndex * this.paginator.pageSize,
        limit: this.paginator.pageSize,
        order: {
          col: this.sort?.active == 'lead_date' ? 'lead_date' : this.sort?.active == 'lead_time' ? 'lead_time' : this.sort?.active == 'lead_type' ? 'lead_type' : this.sort?.active == 'lead_status' ? 'lead_status' : this.sort?.active == undefined ? 'updatedAt' : this.sort?.active,
          dir: this.sort?.direction || 'DESC',
        },
        where: {
          lead_space_id: this.currentActiveTabId,
        },
      };

      this.mergeBulkLeadDateQuery(payload);

      this.applyBulkLeadFilterVisibility(payload);

      return this.api.getFilteredLeads(payload).pipe(catchError(() => of(null)));
    }

    return this.api.getAllData(param).pipe(catchError(() => of(null)));
  }

  /**
   * Loads first leads page, field metadata, lead spaces, and teams in parallel (single round).
   * Applies columns then rows. Each HTTP has catchError so one failure does not block the table.
   */
  private bootstrapLeadModule(): void {
    const client_id = this.localStorage.getClientId();

    const rows$ = this.fetchLeadsListPage$().pipe(
      map((response: any) => {
        if (response === null) {
          this.totalRows = 0;
          return { rows: [], count: 0 };
        }
        this.totalRows = response.count ?? 0;
        return response;
      }),
      catchError(() => {
        this.totalRows = 0;
        return of({ rows: [], count: 0 });
      })
    );

    const fields$ = this.api.getLeadsFields({ client_id }).pipe(
      catchError((err) => {
        console.error('getLeadsFields failed', err);
        return of({ fields: [] as any[] });
      })
    );
    const spaces$ = this.api
      .getAllLeadSpace(this.buildLeadSpaceRequestParam())
      .pipe(catchError(() => of(null)));
    const teams$ = this.tempapi
      .getAllTeams({ client_id })
      .pipe(catchError(() => of([])));

    forkJoin({ fields: fields$, rows: rows$, spaces: spaces$, teams: teams$ })
      .pipe(
        catchError((err) => {
          console.error('lead bootstrap failed', err);
          return of({
            fields: { fields: [] as any[] },
            rows: { rows: [], count: 0 },
            spaces: null as any,
            teams: [] as any[],
          });
        })
      )
      .subscribe({
        next: ({ rows, fields, spaces, teams }) => {
          this.applyLeadsFieldsLayout(fields);
          this.initialLeadsBootstrapResponse = rows;
          this.consumeInitialLeadsBootstrap = true;
          this.applyLeadsRowsToTable(rows);
          if (spaces) {
            this.leadSpaceList = spaces;
          }
          this.teams = Array.isArray(teams) ? teams : [];
          this.loadData();
        },
        error: (e) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          this.toast.error('Something went wrong, please refresh the page');
          console.error(e);
        },
      });
  }

  private applyLeadsFieldsLayout(data: any): void {
    console.log('isFixedColumn', this.isFixedColumn);
    this.displayedColumns = [];
    this.infoArray = [];
    this.filterArray = [];
    this.importColumnsArray = [];
    this.exportColumnArrayObject = [];
    this.exportColumns = [];
    const rawFields = data?.fields;
    this.allLeadFeilds = Array.isArray(rawFields)
      ? [...rawFields].sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
      : [];
         this.initDynamicFields(); // 👈 VERY IMPORTANT
        this.displayedColumns.push('select');
        this.displayedColumns.push('info');
        if (this.isAdmin) {
          this.displayedColumns.push('user_id');
        }

        if (this.isFixedColumn) {

          this.displayedColumns.push('contact_name');
          this.displayedColumns.push('lead_source');
          this.displayedColumns.push('contact_email');
          this.displayedColumns.push('contact_phone');
          this.displayedColumns.push('company_name');
          // this.displayedColumns.push('lead_type');
          // this.displayedColumns.push('lead_status');


          // to show on import screen 
          this.importColumnsArray.push('contact_name');
          this.importColumnsArray.push('contact_email');
          this.importColumnsArray.push('contact_phone');
          this.importColumnsArray.push('country_code');
          this.importColumnsArray.push('company_name');
          this.importColumnsArray.push('lead_source');


          this.exportColumnArrayObject.push({ key: 'contact_name', value: 'Contact Name' })
          this.exportColumnArrayObject.push({ key: 'contact_email', value: 'Contact Email' })
          this.exportColumnArrayObject.push({ key: 'contact_phone', value: 'Contact Phone' })
          this.exportColumnArrayObject.push({ key: 'company_name', value: 'Organization' })
          this.exportColumnArrayObject.push({ key: 'lead_source', value: 'Lead Source' })



          this.filterArray.push({ key: 'contact_name', value: 'Contact Name', type:'text' });
          this.filterArray.push({ key: 'contact_email', value: 'Contact Email',type:'email'  });
          this.filterArray.push({ key: 'contact_phone', value: 'Contact Phone',type:'mobile'  });
          this.filterArray.push({ key: 'company_name', value: 'Organization', type:'text'});


          this.exportColumns.push('Contact Name');
          this.exportColumns.push('Contact Email');
          this.exportColumns.push('Contact Phone');
          this.exportColumns.push('Organization');
          this.exportColumns.push('Lead Source');


          this.exportDataMap['Name'] = 'contact_name';
          this.exportDataMap['Organisation'] = 'company_name';
          this.exportDataMap['Email'] = 'contact_email';
          this.exportDataMap['Contact'] = 'contact_phone';
          this.exportDataMap['Source'] = 'lead_source';
        }


        const normalizeLeadFilterType = (raw: any): 'select' | 'date' | 'text' => {
          const t = String(raw ?? '').toLowerCase();
          if (t === 'select') {
            return 'select';
          }
          if (t === 'date' || t === 'datetime') {
            return 'date';
          }
          return 'text';
        };

        data?.fields?.forEach((element: any) => {

          this.infoArray.push({ key: element.field_name, value: element.label });

          if (element.isVisibleTable == 'true') {
            this.displayedColumns.push(element.field_name);
          }

          this.displayedLebel[element.field_name] = element.label;

          const ft = normalizeLeadFilterType(element.type);
          this.filterArray.push({
            key: element.field_name,
            value:
              element.field_name.charAt(0).toUpperCase() +
              element.field_name.slice(1),
            type: ft,
            options: ft === 'select' ? element.data : []
          });

          this.importColumnsArray.push(element.field_name);

          this.exportColumnArrayObject.push({ key: element.field_name, value: element.label })
        });


        this.filterArray.push({ key: 'lead_time', value: 'Time',type:'time' });
        this.filterArray.push({ key: 'lead_type', value: 'Lead Type',type:'select' });
        this.filterArray.push({ key: 'lead_status', value: 'Lead Status',type:'select'  });
        if (this.isAdmin) {
          this.filterArray.push({ key: 'user_id', value: 'Lead Owner', type: 'number' });
          this.filterArray.push({ key: 'created_by', value: 'Created By', type: 'number' });
        }
        this.filterArray.push({ key: 'lead_id', value: 'Lead Id' ,type:'number'});
        // this.exportColumns = [];
        this.exportDataMap = {};


        data?.fields?.forEach((element: any) => {
          this.exportColumns.push(element.label);
          this.exportDataMap[element.label] = element.field_name;
          if (element.sub_fields && element.sub_fields.length > 0) {
            this.fieldValues[element.field_name + '|subf'] = [];
          }
          let inc = 0;
          if (element.sub_fields && element.sub_fields.length > 0) {
            this.copyOfFields[element.field_name] = element.sub_fields.length;
            element.sub_fields.forEach((sub: any) => {
              this.exportColumns.push(sub.label);
              this.exportDataMap[sub.label] = sub.field_name;
              this.fieldValues[element.field_name + '|subf'].push({
                [sub.field_name + '|' + inc]: '',
              });
              this.displayedLebel[sub.field_name] = sub.label;
              const sft = normalizeLeadFilterType(sub.type);
              this.filterArray.push({
                key: sub.field_name,
                value:
                  (sub.label && String(sub.label).trim()) ||
                  sub.field_name.charAt(0).toUpperCase() + sub.field_name.slice(1),
                type: sft,
                options: sft === 'select' ? sub.data : [],
              });
              if (sub.isVisibleTable == 'true') {
                this.displayedColumns.push(sub.field_name);
              }
              inc++;
            });
          }
        });


        // fixed colums irrespective of fixed column

        this.displayedColumns.push('lead_type');
        this.displayedColumns.push('lead_status');
        this.displayedColumns.push('action');


        this.importColumnsArray.push('lead_type');
        this.importColumnsArray.push('lead_status');
        this.importColumnsArray.push('action');


        this.exportColumns.push('Lead Date');
        this.exportColumns.push('Lead Time');
        this.exportColumns.push('Lead Type');
        this.exportColumns.push('Lead Status');
        this.exportColumns.push('Assign To');


        this.exportColumnArrayObject.push({ key: 'lead_date', value: 'Lead Date' })
        this.exportColumnArrayObject.push({ key: 'lead_time', value: 'Lead Time' })
        this.exportColumnArrayObject.push({ key: 'lead_type', value: 'Lead Type' })
        this.exportColumnArrayObject.push({ key: 'lead_status', value: 'Lead Status' })
        this.exportColumnArrayObject.push({ key: 'user_id', value: 'Assign To' })



        this.exportDataMap['Lead Date'] = 'lead_date';
        this.exportDataMap['Lead Time'] = 'lead_time';
        this.exportDataMap['Lead Type'] = 'lead_type';
        this.exportDataMap['Lead Status'] = 'lead_status';
        this.exportDataMap['Assign To'] = 'user_id';

    this.renderColumns = this.displayedColumns.filter((col) => col !== 'select');
  }

  getLeadsFields() {
    const param = {
      client_id: this.localStorage.getClientId(),
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => this.applyLeadsFieldsLayout(data),
      error: (e) => {
        this.applyLeadsFieldsLayout({ fields: [] });
        this.initialLoad = false;
        this.toast.error('Something went wrong, please refresh the page');
        console.error(e);
      },
    });
  }

  getLeadStatusClass(status?: string | null): string {
    return getLeadStatusBadgeClass(status);
  }

  hasLeadStatusBadge(_status?: string | null): boolean {
    return true;
  }

  getLeadStatusLabel(status?: string | null): string {
    return normalizeLeadStatus(status);
  }

  getLeadTypeLabel(type?: string | null): string {
    return normalizeLeadType(type);
  }

  showInfo(row: any, event: MouseEvent) {
    this.hoveredRow = row;
    this.positionInfoPopup(event);
    this.current_id_hover = row.lead_id;
  }

  private positionInfoPopup(event: MouseEvent): void {
    const POPUP_W = 340;
    const POPUP_H = 420;
    const MARGIN = 12;

    let x = event.clientX + 20;
    let y = event.clientY - 10;

    if (x + POPUP_W > window.innerWidth - MARGIN) {
      x = event.clientX - POPUP_W - 10;
    }
    if (y + POPUP_H > window.innerHeight - MARGIN) {
      y = window.innerHeight - POPUP_H - MARGIN;
    }
    if (y < MARGIN) {
      y = MARGIN;
    }

    this.leftPosition = x;
    this.topPosition = y;
  }

  isInfoPopupMobileView(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 768;
  }

  onInfoIconClick(element: any, event: MouseEvent): void {
    if (this.isInfoPopupMobileView()) {
      this.toggleMobileInfoLead(element.lead_id);
      return;
    }
    this.showInfo(element, event);
  }
  onMouseMove(row: any, event: MouseEvent): void {
    this.current_id_hover = row.lead_id;
  }
  openDialog(element: any) {

  }
  hideInfo() {
    this.current_id_hover = '';
    this.currentMobilePopupLeadId = null;
  }

  searchFilter(query: any) {
    this.searchQuery.setValue(query);
  }
  ResetDateFilter(event: any) {
    this.dateQuery.setValue('');
  }
  ResetFilter(event: any) {
    this.searchQuery.setValue('');
  }
  clearleadForm() {
    this.lead = new Lead();
  }

  announceSortChange(evn: any) {
    // this.sort.sortChange.emit(evn);
  }

  // load Initial table data from based on source type
  loadData() {
    try {
      if (!this.sortPageResetBound && this.sort) {
        this.sortPageResetBound = true;
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      }
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort?.sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            if (
              this.consumeInitialLeadsBootstrap &&
              this.initialLeadsBootstrapResponse != null
            ) {
              this.consumeInitialLeadsBootstrap = false;
              const cached = this.initialLeadsBootstrapResponse;
              this.initialLeadsBootstrapResponse = null;
              return of(cached);
            }
            this.isDataLoading = true;
            return this.fetchLeadsListPage$();
          }),
          map((response: any) => {
            if (response === null) {
              this.totalRows = 0;
              return { rows: [], count: 0 };
            }
            this.totalRows = response.count ?? 0;
            return response;
          })
        )
        .subscribe({
          next: (data) => {
            const rows = Array.isArray(data?.rows) ? data.rows : [];
            rows.forEach((e: any, i: any) => {
              let index = this.temp.findIndex((p: any) => {
                if (p.lead_id === e.lead_id) {
                  rows[i].isSelected = true;
                }
              });
            });
            this.dataSource = new MatTableDataSource<any>(rows);
            this.dataSource.paginator = null;
            this.leadRecords = rows;
            this.initialLoad = false;
            this.isDataLoading = false;
            this.bulkLeadFilterLoading = false;
          },
          error: (e) => {
            this.initialLoad = false;
            this.isDataLoading = false;
            this.bulkLeadFilterLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }

  reloadData() {
    this.isDataLoading = true;
    this.temp = [];
    this.paginator.pageIndex = 0;
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {


            let param: any = {

              where: this.buildGetAllLeadsBaseWhere(),
              filter: {},
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,

              order: {
                col: this.sort?.active == 'lead_date' ? 'lead_date' : this.sort?.active == 'lead_time' ? 'lead_time' : this.sort?.active == 'lead_type' ? 'lead_type' : this.sort?.active == 'lead_status' ? 'lead_status' : this.sort?.active == undefined ? "updatedAt" : this.sort?.active,
                dir: this.sort?.direction || 'DESC',
              },
            };

            if (this.currentActiveTabId) {
              param.where = { ...param.where, lead_space_id: this.currentActiveTabId }
            }

            this.mergeLeadListDateQuery(param);
            this.applyLeadListVisibility(param);

            this.mergeAllowedSearchIntoFilter(param);
            this.applyLeadSearchFilters(param);

            if (this.isBulkLeadFilter) {

              const payload: any = {
                advanced_filters: this.bulkLeadFilterData,
                client_id: this.localStorage.getClientId(),
                center_id: this.localStorage.getCenterId(),
                page: this.paginator.pageIndex * this.paginator.pageSize,
                limit: this.paginator.pageSize,
                "where": {
                  "lead_space_id": this.currentActiveTabId
                },
                "order": {
                  "col": this.sort?.active == 'lead_date' ? 'lead_date' : this.sort?.active == 'lead_time' ? 'lead_time' : this.sort?.active == 'lead_type' ? 'lead_type' : this.sort?.active == 'lead_status' ? 'lead_status' : this.sort?.active == undefined ? "updatedAt" : this.sort?.active,
                  "dir": this.sort?.direction || 'DESC',
                }
              }

              this.mergeBulkLeadDateQuery(payload);

              this.applyBulkLeadFilterVisibility(payload);

              return this.api.getFilteredLeads(payload)
                .pipe(
                  catchError(() => of(null)));

            } else {
              return this.api
                .getAllData(param)
                .pipe(
                  catchError(() => of(null)));
            }
          }),
          map((response: any) => {
            if (response === null) {
              this.totalRows = 0;
              return { rows: [], count: 0 };
            }
            this.totalRows = response.count ?? 0;
            return response;
          })
        )
        .subscribe({
          next: (data) => {
            const rows = Array.isArray(data?.rows) ? data.rows : [];
            rows.forEach((e: any, i: any) => {
              let index = this.temp.findIndex((p: any) => {
                if (p.lead_id === e.lead_id) {
                  rows[i].isSelected = true;
                }
              });
            });
            this.dataSource = new MatTableDataSource<any>(rows);
            this.dataSource.paginator = null;
            this.dataSource.sort = this.sort;
            this.initialLoad = false;
            this.isDataLoading = false;
            this.bulkLeadFilterLoading = false;
            this.cdr.detectChanges();
          },
          error: (e) => {
            this.initialLoad = false;
            this.isDataLoading = false;
            this.bulkLeadFilterLoading = false;
            this.cdr.detectChanges();
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }


  reloadDataWithoutPageChange() {
    this.isDataLoading = true;
    this.temp = [];
    // this.paginator.pageIndex = 0;
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {


            let param: any = {

              where: this.buildGetAllLeadsBaseWhere(),
              filter: {},
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,

              order: {
                col: this.sort?.active == 'lead_date' ? 'lead_date' : this.sort?.active == 'lead_time' ? 'lead_time' : this.sort?.active == 'lead_type' ? 'lead_type' : this.sort?.active == 'lead_status' ? 'lead_status' : this.sort?.active == undefined ? "updatedAt" : this.sort?.active,
                dir: this.sort?.direction || 'DESC',
              },
            };

            if (this.currentActiveTabId) {
              param.where = { ...param.where, lead_space_id: this.currentActiveTabId }
            }

            this.mergeLeadListDateQuery(param);
            this.applyLeadListVisibility(param);

            this.mergeAllowedSearchIntoFilter(param);
            this.applyLeadSearchFilters(param);

            if (this.isBulkLeadFilter) {

              const payload: any = {
                advanced_filters: this.bulkLeadFilterData,
                client_id: this.localStorage.getClientId(),
                center_id: this.localStorage.getCenterId(),
                page: this.paginator.pageIndex * this.paginator.pageSize,
                limit: this.paginator.pageSize,
                "where": {
                  "lead_space_id": this.currentActiveTabId
                },
                "order": {
                  "col": this.sort?.active == 'lead_date' ? 'lead_date' : this.sort?.active == 'lead_time' ? 'lead_time' : this.sort?.active == 'lead_type' ? 'lead_type' : this.sort?.active == 'lead_status' ? 'lead_status' : this.sort?.active == undefined ? "updatedAt" : this.sort?.active,
                  "dir": this.sort?.direction || 'DESC',
                }
              }

              this.mergeBulkLeadDateQuery(payload);

              this.applyBulkLeadFilterVisibility(payload);

              return this.api.getFilteredLeads(payload)
                .pipe(
                  catchError(() => of(null)));

            } else {
              return this.api
                .getAllData(param)
                .pipe(
                  catchError(() => of(null)));
            }
          }),
          map((response: any) => {
            if (response === null) {
              this.totalRows = 0;
              return { rows: [], count: 0 };
            }
            this.totalRows = response.count ?? 0;
            return response;
          })
        )
        .subscribe({
          next: (data) => {
            const rows = Array.isArray(data?.rows) ? data.rows : [];
            rows.forEach((e: any, i: any) => {
              let index = this.temp.findIndex((p: any) => {
                if (p.lead_id === e.lead_id) {
                  rows[i].isSelected = true;
                }
              });
            });
            this.dataSource = new MatTableDataSource<any>(rows);
            this.dataSource.paginator = null;
            this.dataSource.sort = this.sort;
            this.initialLoad = false;
            this.isDataLoading = false;
            this.bulkLeadFilterLoading = false;
            this.cdr.detectChanges();
          },
          error: (e) => {
            this.initialLoad = false;
            this.isDataLoading = false;
            this.bulkLeadFilterLoading = false;
            this.cdr.detectChanges();
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }

  isDataLoading: boolean = true;



  isSourceImage(source: string): boolean {
    return isLeadSourceImage(source);
  }

  getLeadSourceImg(source: string): string {
    return resolveLeadSourceImg(source);
  }





  // HostListener to detect clicks outside the component
  // @HostListener('document:click', ['$event.target'])
  // onDocumentClick(event: Event): void {
  //   const clickedInside = this.eRef.nativeElement.contains(event.target);
  //   const specificElement = document.getElementById('action_tab_button'); // Replace with the class or ID of the element you want to track
  //   if(specificElement) {
  //     //this.isDivVisible = false
  //   }

  //   const clickedOnSpecificElement = specificElement?.contains(event.target as Node);
  //   console.log(clickedOnSpecificElement)
  //   if (!clickedInside && !clickedOnSpecificElement) {
  //     this.handleClickOutside();
  //   }
  // }
  hideDiv() {
    alert()
  }
  deleteOpen(spaceId: number): void {
    if (this.currentSpace_id == spaceId) {
      this.currentSpace_id = null;
    } else {
      if (this.currentActiveTabId !== spaceId) {
        this.handleStoreCurrentSpaceId(spaceId, true)
      } else {
        this.currentSpace_id = spaceId;
      }
    }
  }

  handleChangeLeadSpaceName(): void {
    this.btnLoading = true;
    // {
    //   "client_id":"",
    //   "id":"" -->tab_id,
    //   "space_name":"", -->updated tab name
    //   }

    const payload = {
      client_id: this.localStorage.getClientId(),
      id: this.idToEdit,
      space_name: this.nameLeadSpaceToEdit,
    };

    this.api.updateLeadSpace(payload).subscribe({
      next: (res: any) => {
        this.toast.success("Updated successfully");
        this.getLeadSpace(this.nameLeadSpaceToEdit);
        this.modalService.dismissAll();
        this.btnLoading = false;
      },
      error: (err: any) => {
        this.toast.error(err.error.message);
        this.btnLoading = false;
      },
      complete: () => {
        this.btnLoading = false;
      }
    });
  }


  handleOpenEditLeadSpaceTab(content: any, spaceId: any, space_name: any): void {

    this.idToEdit = spaceId;
    this.nameLeadSpaceToEdit = space_name;

    this.modalService.open(content, {
      size: 'md',
      scrollable: true,
      centered: true,
    });

    this.currentSpace_id = null;
    console.log(spaceId)
  }

  handleOpenDeleteSpaceModel(content: any, spaceId: number): void {
    this.idToDelete = spaceId;
    this.modalService.open(content, {
      size: 'md',
      scrollable: true,
      centered: true,
    });
    this.currentSpace_id = null;
  }

  handleDeleteLeadSpace(): void {
    this.btnLoading = true;

    const payload = {
      client_id: this.localStorage.getClientId(),
      id: this.idToDelete,
    };
    this.api.deleteLeadSpace(payload).subscribe({
      next: (res: any) => {
        this.getLeadSpace();
        this.changeTab('all_leads');
        setTimeout(() => {
          // all_leads_tab click on this tab 

          this.toast.success("Lead Space Deleted Successfully");
          this.modalService.dismissAll();
          this.btnLoading = false;

        }, 1500);

      },
      error: (err: any) => {
        this.toast.error("An error occured while deleting the lead space");
        this.btnLoading = false;

      },

    });
  }


  closeMenu(): void {
    this.currentSpace_id = null; // Reset to hide the menu

  }


  handleOpenMoveLeadsModel(content: any, element: any): void {
    this.leadToMove = element;
    this.modalService.open(content, {
      size: 'md',
      scrollable: true,
      centered: true,
    });
  }

  handleMoveLeads(): void {

    if (this.selectedLeadSpace) {
      this.formAction = 'update';
      this.editFieldValues = this.leadToMove;
      this.preUserId = this.leadToMove.user_id;
      this.editFieldValues.lead_space_id = this.selectedLeadSpace;

      this.btnLoading = true;

      this.SaveLead(true)
    }
    else {
      this.toast.error("Please select lead space name")
    }




  }


  handleBulkMoveLeads(): void {

    if (this.selectedLeadSpace) {
      const payload = {
        client_id: this.localStorage.getClientId(),
        lead_space_id: this.selectedLeadSpace,
        lead_id: this.temp.map((item: any) => item.lead_id),
        user_id: this.localStorage.getUserId(),
      };
      this.btnLoading = true;

      this.api.updateBulkLead(payload).subscribe({
        next: (res: any) => {
          this.toast.success("Leads moved successfully");
          this.temp = [];
          this.reloadData();
          this.modalService.dismissAll();
          this.btnLoading = false;
        },
        error: (err: any) => {
          this.toast.error(err.error.message);
          this.btnLoading = false;
        },
        complete: () => {
          this.btnLoading = false;
        }
      });
    }
    else {
      this.toast.error("Please select lead space name")
    }




  }





  checkNull(data: any, col: any) {

    let row = ""
    try {
      if (data['fields'][col] != null) {
        row = data['fields'][col]
        // console.log("--->",data['fields'][col])
      }
    }
    catch (err) {

    }


    return row;
  }

  /** Include configured lead / sub-field keys so search reaches the API (not only hardcoded defaultFilter). */
  private allowSearchFilterKey(key: string): boolean {
    if (this.defaultFilter.includes(key)) {
      return true;
    }
    return this.filterArray.some((f: any) => f.key === key);
  }

  /** Match getAllLeads contract: string client_id / center_id in where. */
  private buildGetAllLeadsBaseWhere(): Record<string, any> {
    return {
      client_id: String(this.localStorage.getClientId()),
      center_id: String(this.localStorage.getCenterId()),
    };
  }

  /** Non-admins see leads assigned to them (user_id) or created by them (created_by). */
  private applyLeadListVisibility(param: Record<string, any>): void {
    if (!this.isAdmin) {
      param['where'] = {
        ...param['where'],
        center_id: String(this.center_id ?? this.localStorage.getCenterId()),
      };
    }
    applyLeadVisibilityUserId(
      param,
      this.localStorage.getUserId(),
      this.isAdmin,
      this.localStorage.getClientId()
    );
  }

  private applyBulkLeadFilterVisibility(payload: Record<string, any>): void {
    applyLeadVisibilityUserId(
      payload,
      this.localStorage.getUserId(),
      this.isAdmin,
      this.localStorage.getClientId()
    );
  }

  /** Always send filter as an object; only allowed keys (never raw "" from reset). */
  private mergeAllowedSearchIntoFilter(param: { filter: Record<string, any> }): void {
    param.filter = {};
    const raw = this.searchQuery.value;
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
      return;
    }
    for (const [key, value] of Object.entries(raw)) {
      if (!this.allowSearchFilterKey(key)) {
        continue;
      }
      const k = key;
      param.filter[k] = value;
    }
  }

  /** Promote lead_id / Lead Owner (user_id) / Created By (created_by) to exact where matches. */
  private applyLeadSearchFilters(param: { filter: Record<string, any>; where: Record<string, any> }): void {
    const leadId = param.filter['lead_id'];
    if (leadId !== undefined && leadId !== null && String(leadId).length > 0) {
      param.where = { ...param.where, lead_id: leadId };
      delete param.filter['lead_id'];
    }
    this.applyExactLeadUserFieldFilter(param, 'user_id');
    this.applyExactLeadUserFieldFilter(param, 'created_by');
  }

  private applyExactLeadUserFieldFilter(
    param: { filter: Record<string, any>; where: Record<string, any> },
    field: 'user_id' | 'created_by'
  ): void {
    if (!Object.prototype.hasOwnProperty.call(param.filter, field)) {
      return;
    }
    const raw = param.filter[field];
    delete param.filter[field];
    if (raw === undefined || raw === null || raw === '') {
      return;
    }
    if (raw === '__unassigned__') {
      param.where = { ...param.where, [field]: null };
      return;
    }
    const parsed = Number(raw);
    param.where = {
      ...param.where,
      [field]: Number.isFinite(parsed) ? parsed : raw,
    };
  }

  private mergeLeadListDateQuery(param: any) {
    const dq = this.dateQuery.value;
    if (!dq || typeof dq !== 'object') {
      return;
    }
    if (dq.dynamicFieldDateFilter) {
      param.dynamicFieldDateFilter = dq.dynamicFieldDateFilter;
    }
    if (dq.startDate) {
      param.startDate = dq.startDate;
    }
    if (dq.endDate) {
      param.endDate = dq.endDate;
    }
  }

  private mergeBulkLeadDateQuery(payload: any) {
    const dq = this.dateQuery.value;
    if (!dq || typeof dq !== 'object') {
      return;
    }
    if (dq.dynamicFieldDateFilter) {
      payload.dynamicFieldDateFilter = dq.dynamicFieldDateFilter;
    }
    if (dq.startDate) {
      payload.startDate = new Date(dq.startDate);
    }
    if (dq.endDate) {
      payload.endDate = new Date(dq.endDate);
    }
  }

  /**
   * Merges toolbar date payloads so lead_date range and JSON field dates (e.g. Deadline) stay independent.
   */
  dateFilter(event: any) {
    if (event === '' || event == null) {
      this.dateQuery.setValue('');
      return;
    }
    if (typeof event !== 'object' || Array.isArray(event)) {
      this.dateQuery.setValue(event);
      return;
    }

    const prevRaw = this.dateQuery.value;
    const prev =
      prevRaw && typeof prevRaw === 'object' && !Array.isArray(prevRaw)
        ? { ...prevRaw }
        : {};

    if (Object.prototype.hasOwnProperty.call(event, 'dynamicFieldDateFilter')) {
      const v = event.dynamicFieldDateFilter;
      if (v && typeof v === 'object') {
        prev.dynamicFieldDateFilter = v;
      } else {
        delete prev.dynamicFieldDateFilter;
      }
    }

    if (Object.prototype.hasOwnProperty.call(event, 'startDate')) {
      if (event.startDate) {
        prev.startDate = event.startDate;
      } else {
        delete prev.startDate;
      }
    }
    if (Object.prototype.hasOwnProperty.call(event, 'endDate')) {
      if (event.endDate) {
        prev.endDate = event.endDate;
      } else {
        delete prev.endDate;
      }
    }

    this.dateQuery.setValue(Object.keys(prev).length > 0 ? prev : '');
  }
  followUps(content: any, element: any) {
    this.editFieldValues = element;
    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true
    });
    this.getFollowUps(element.lead_id);
  }
  getFollowUps(id: any) {
    this.followupLoading = true;
    this.leadsFollowList = [];
    let param = {
      lead_id: id.toString(),
      client_id: this.localStorage.getClientId(),
    };
    this.api.getLeadsFollowup(param).subscribe({
      next: (res) => {
        this.leadsFollowList = res || [];
        this.followupLoading = false;
      },
      error: (err) => {
        this.followupLoading = false;
      },
    });
  }

  previousTab = 'all_leads';
  changeTab(tab: any) {

    if (this.previousTab == tab) {
      return
    }

    this.dataSource.data = [];
    this.currentTab = tab;
    this.currentActiveTabId = null;
    this.isDataLoading = true;
    this.reloadData();
    this.previousTab = tab;
    this.currentSpace_id = null;
    this.cdr.detectChanges();
  }

  open(content: any) {
    this.isSubmitted = false;
    this.btnLoading = false;
    this.formAction = 'add';
    this.leadFieldDateCache.clear();
    this.clearleadForm();
    this.modalService
      .open(content, {
        size: 'xl', scrollable: true,
        centered: true, backdrop: 'static', keyboard: false
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  openList(content: any) {
    if (this.temp.length < 1) {
      this.toast.error('Please select a record to create the list !');
    } else {
      this.formAction = 'add';
      this.modalService
        .open(content, {
          size: 'lg', scrollable: true,
          centered: true, backdrop: 'static', keyboard: false
        })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }

  openBulkMove(content: any) {
    if (this.temp.length < 1) {
      this.toast.error('Please select a record to create the list !');
    } else {
      this.formAction = 'add';
      this.modalService
        .open(content, {
          size: 'md', scrollable: true,
          centered: true, backdrop: 'static', keyboard: false
        })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }

  openBulkDelete(content: any) {
    if (this.temp.length < 1) {
      this.toast.error('Please select a record to create the list !');
    } else {
      this.formAction = 'add';
      this.modalService
        .open(content, {
          size: 'md', scrollable: true,
          centered: true, backdrop: 'static', keyboard: false
        })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }

  openBulkCreateContactGroup(content: any) {
    if (this.temp.length < 1) {
      this.toast.error('Please select at least one lead.');
      return;
    }

    this.modalService
      .open(content, {
        size: 'lg',
        scrollable: true,
        centered: true,
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  onContactGroupCreatedFromLeads(): void {
    this.temp = [];
    this.reloadData();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  edit(content: any, object: any) {
    this.isSubmitted = false;
    this.btnLoading = false;
    this.leadFieldDateCache.clear();
    this.editFieldValues = {};
    this.preUserId = '';
    this.formAction = 'update';
    this.remarkValue = '';
    this.notification_date = '';
    this.next_action = '';
    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true
    });
    this.editFieldValues = object;

    if (this.editFieldValues.contact_phone) {
      const withPlus = this.editFieldValues.contact_phone.startsWith('+') 
      ? this.editFieldValues.contact_phone 
      : '+' + this.editFieldValues.contact_phone;
      this.editFieldValues.contact_phone = withPlus;      
    }
    if (this.editFieldValues.fields == null || this.editFieldValues.fields == undefined) {
      this.editFieldValues.fields = {}
    }
    this.preUserId = object.user_id;

    // set assignToTeam true if object temm_id is not null
    if (object.team_id != null && object.team_id != undefined && object.team_id != 0) {
      this.assignToTeam = true;
    } else {
      this.assignToTeam = false;
    }
    if(this.editFieldValues.team_id == ""){
      this.editFieldValues.team_id = null;
    }

    const appliedCrmPipeline = applyCrmSourcePipeline(this.editFieldValues, this.pipelineData);
    if (
      !appliedCrmPipeline &&
      (this.editFieldValues.pipeline_id == null || this.editFieldValues.pipeline_id == undefined) &&
      this.pipelineData?.[0]
    ) {
      this.editFieldValues.pipeline_id = this.pipelineData[0].pipeline_id;
    }
    this.getLeadStages(this.editFieldValues.pipeline_id);

  }

  onEditLeadSourceChange(): void {
    if (applyCrmSourcePipeline(this.editFieldValues, this.pipelineData)) {
      this.getLeadStages(this.editFieldValues.pipeline_id);
    }
  }

  isCrmImportedSource(source: unknown): boolean {
    return isCrmLeadSource(source);
  }

  scrollToError(e: any, container: HTMLElement) {
    if (!e.form.valid) {
      Object.keys(e.form.controls).forEach((key) => {
        if (e.form.controls[key].errors != null) {
          const el = document.getElementById(key);
          if (el) {
            const offset = el.offsetTop - 100;
            container.scrollTo({
              top: offset,
              behavior: 'smooth',
            });
            el.focus();
          }
        }
      });
    }
  }

  handleClickOutside() {
    console.log("alert 123")

  }

  // save Lead Data
  SaveLead(isValid: any) {
    console.log(this.currentActiveTabId);
    this.isSubmitted = true;

    const linkedInValues =
      this.formAction === 'update'
        ? this.editFieldValues?.fields
        : this.fieldValues;
    const linkedInCheck = validateLeadLinkedInFields(
      this.allLeadFeilds,
      linkedInValues
    );
    if (!linkedInCheck.valid) {
      return;
    }

    if (isValid) {
      if (this.formAction == 'add') {
        
        this.isSubmitted = true;
        this.btnLoading = true;
        this.createFieldFormValue.client_id = this.localStorage.getClientId();
        this.createFieldFormValue.center_id = this.localStorage.getCenterId();
        this.createFieldFormValue.created_by = this.localStorage.getUserId();
        this.createFieldFormValue.fields = this.fieldValues;
        this.createFieldFormValue.lead_date = moment().format('YYYY-MM-DD');
        this.createFieldFormValue.lead_time = moment().format('HH:mm');
        this.createFieldFormValue.lead_space_id = this.currentActiveTabId || null;


        if (this.isCenter) {
          this.createFieldFormValue.center_id = this.center_id;
        }
        if (this.createFieldFormValue.user_id) {
          this.users.filter((user: any) => {
            if (user.user_id == this.createFieldFormValue.user_id) {
              this.createFieldFormValue.email = user.email;
              this.createFieldFormValue.username =
                user.prefix + ' ' + user.fname + ' ' + user.lname;
            }
          });
        }

        if (!this.createFieldFormValue.user_id) {
          this.createFieldFormValue.user_id = null
          this.createFieldFormValue.email = null
          this.createFieldFormValue.username = null
        }
        
        if (this.createFieldFormValue.team_id == "") {
          this.createFieldFormValue.team_id =null; 
        }
      
        this.api.addLeadData(this.createFieldFormValue).subscribe({
          next: (c) => {
            this.modalService.dismissAll();
            if (!this.currentActiveTabId || this.currentActiveTabId == 'all_leads' || this.currentActiveTabId == null || this.currentActiveTabId == undefined) {
              this.reloadData();
            } else {
              this.reloadData()
            }
            this.btnLoading = false;
            this.toast.success('Lead Added Successfully', 'Success!!');
            this.tracker.track("Add", "Leads", "User Added:New Lead ", c.lead_id)
            this.resetFormValues();
          },
          error: (e) => {

            this.btnLoading = false;
          },
          complete: () => { },
        });
      } else if (this.formAction == 'update') {

        console.log("contact_phone", this.editFieldValues.contact_phone );
        this.btnLoading = true;
        this.editFieldValues.center_id = this.localStorage.getCenterId();
        if (this.editFieldValues.user_id) {
          if (this.preUserId != this.editFieldValues.user_id) {
            this.users.filter((user: any) => {
              if (user.user_id == this.editFieldValues.user_id) {
                this.editFieldValues.email = user.email;
                this.editFieldValues.username =
                  user.prefix + ' ' + user.fname + ' ' + user.lname;
              }
            });
          }
        }

        console.log(this.editFieldValues) 

        this.api.updateLead(this.editFieldValues).subscribe({
          next: (c) => {
            this.modalService.dismissAll();

            this.isSubmitted = false;
            this.btnLoading = false;
            this.toast.success('Lead Updated Successfully', 'Success!!');
            this.tracker.track("Update", "Leads", "User Update:Existing Lead Details", this.editFieldValues.lead_id)
            this.lead = new Lead();
            this.selectedLeadSpace = null;
            this.reloadData();

          },
          error: (e) => {
            this.btnLoading = false;
            this.isSubmitted = false;
          },
          complete: () => { },
        });
      }
      // console.log(this.lead)
    }
  }
  fnCheckNotificationDate(event: any) {
    this.isReminderChecked = event.target.checked;
    if (this.isReminderChecked == false) {
      this.notification_date = ""
    }
  }

  get editContactCountryIso(): CountryISO {
    return regionForDialCode(this.editFieldValues?.['country_code']);
  }

  get editContactPhone() {
    return phoneControlValue(this.editFieldValues['country_code'], this.editFieldValues['contact_phone']);
  }

  set editContactPhone(value: any) {
    assignIntlPhone(this.editFieldValues, 'contact_phone', value);
  }

  get createContactPhone() {
    return phoneControlValue(this.createFieldFormValue['country_code'], this.createFieldFormValue['contact_phone']);
  }

  set createContactPhone(value: any) {
    assignIntlPhone(this.createFieldFormValue, 'contact_phone', value);
  }
  

  updateLeadsRemarks() {
    //alert(this.isCron)
    if (((this.isReminderChecked == true && this.notification_date == "") && this.isCron == 'True')) {
      this.toast.error("Please add notification reminder date")
    }
    else
      if (this.next_action == "") {
        this.toast.error("Please add next action")
      }
      else if (this.remarkValue == "") {
        this.toast.error("Please add text in update detail")
      }
      else {
        this.btnUpdateLoading = true;
        const user_id = parseInt(this.localStorage.getUserId());
        this.leadFolloup = {
          client_id: this.localStorage.getClientId(),
          lead_id: this.editFieldValues.lead_id,
          center_id: this.localStorage.getCenterId(),
          date: moment().format('YYYY-MM-DD'),
          time: moment().format('HH:mm'),
          remarks: this.remarkValue,
          notification_date:
            this.notification_date == '' ? null : this.notification_date,
          user_id: user_id,
          next_action: this.next_action,
          updated_by: {
            "email": this.localStorage.getEmail(),
          }
        };
        this.api.addLeadFollowUp(this.leadFolloup).subscribe({
          next: (c) => {
            this.btnUpdateLoading = false;
            this.isSubmitted = false;
            this.toast.success("Update Added successfully")
            this.tracker.track("Followup", "Leads", "User Followup:Lead Followup Added Successfully", this.editFieldValues.lead_id)
            this.getFollowUps(this.editFieldValues.lead_id);
            this.reloadData();
            this.remarkValue = ""
            this.notification_date = ""
            this.next_action = ""
            //this.modalService.dismissAll();
          },
          error: (e) => {
            this.btnLoading = false;
            this.isSubmitted = false;
          },
          complete: () => { },
        });
      }

  }
  deleteLead() {
    this.btnLoading = true;
    this.api.deleteLeadData(this.deleteParam).subscribe({
      next: (data: any) => {
        this.modalService.dismissAll();
        this.btnLoading = false;
        this.toast.success("Lead Deleted Successfully");
        this.reloadData();
      },
      error: (error: any) => {
        this.btnLoading = false;
        this.toast.error('An error occured');
      },
    });
    this.tracker.track("Delete", "Leads", "User Action:Lead Deleted", this.deleteParam.lead_id)
  }
  deleteFieldModal(content: any, id: any) {
    let param = {
      lead_id: id,
      client_id: this.localStorage.getClientId(),
    };
    this.deleteParam = param;
    this.modalService.open(content, {
      size: 'l',
      scrollable: true,
      centered: true,
    });
  }
  resetFormValues() {
    this.leadFieldDateCache.clear();
    this.createFieldFormValue = {
      fields: {},
      lead_date: '',
      lead_status:'',
      lead_type:'',
      lead_source:'',
      lead_time: '',
      user_id: '',
      team_id: '',
      isEdit: false
    };
    this.assignToTeam = false;
    this.fieldValues = {};
    this.allLeadFeilds.forEach((element: any) => {
      if (element.sub_fields && element.sub_fields.length > 0) {
        this.fieldValues[element.field_name + '|subf'] = [];
      }
      let inc = 0;
      if (element.sub_fields && element.sub_fields.length > 0) {
        element.sub_fields.forEach((sub: any) => {
          this.fieldValues[element.field_name + '|subf'].push({
            [sub.field_name + '|' + inc]: '',
          });
          inc++;
        });
      }
    });
    this.isSubmitted = false;
  }

  SaveLeadFollowUp(isValid: any) {
    this.isSubmitted = true;
    if (isValid) {
      this.btnLoading = true;
      this.leadFolloup.lead_id = this.lead.lead_id;
      this.leadFolloup.client_id = this.localStorage.getClientId();
      this.leadFolloup.center_id = this.localStorage.getCenterId();
      this.leadFolloup.updated_by = {
        email: this.localStorage.getEmail(),
      };

      this.lead.hospital_id = this.localStorage.getHospitalId();
      this.api.addLeadFollowUp(this.leadFolloup).subscribe({
        next: (c) => {
          this.btnLoading = false;
          this.isSubmitted = false;
          this.toast.success('Lead Followup Added Successfully', 'Success!!');
          this.getFollowUps(this.leadFolloup.lead_id);
          this.reloadData();
        },
        error: (e) => {
          this.btnLoading = false;
          this.isSubmitted = false;
        },
        complete: () => { },
      });
    }
  }
  importData(event: any) {
    if (event.length > 0) {
      this.uploadBtnLoading = true
      const importRows = event.map((row: any) => ({
        ...row,
        created_by: row.created_by ?? this.localStorage.getUserId(),
      }));
      const phoneErrors: { row: number; message: string }[] = [];
      importRows.forEach((row: any, index: number) => {
        if (!String(row.contact_phone || '').trim()) return;
        const resolved = resolvePhone(row.country_code, row.contact_phone);
        if (!resolved.ok) {
          phoneErrors.push({ row: index + 2, message: resolved.error || 'Invalid phone number' });
          return;
        }
        row.contact_phone = resolved.nationalNumber;
        row.country_code = resolved.countryCode;
      });
      if (phoneErrors.length) {
        this.uploadBtnLoading = false;
        this.toast.error(formatPhoneImportErrors(phoneErrors), 'Import validation', phoneImportToastOptions);
        return;
      }
      this.api.createBulkLead(importRows).subscribe({
        next: (res) => {
          if (res) {
            this.uploadBtnLoading = false
            this.toast.success("Data uploaded Successfully")
            this.tracker.track(
              "Import",
              "Lead",
              `Bulk leads imported successfully. Count: ${event.length}`
            );

            this.modalService.dismissAll()
            if (this.currentActiveTabId != undefined || this.currentActiveTabId != "") {
              this.reloadData()
            }
            else {
              this.reloadData();
            }

          }
        },
        error: (e) => {
          this.uploadBtnLoading = false
          const apiErrors = readImportErrors(e);
          this.toast.error(
            apiErrors.length ? formatPhoneImportErrors(apiErrors) : 'Lead import failed',
            'Import validation',
            phoneImportToastOptions
          );
        }
      })
    }
    else {

      this.toast.error("Please Upload Data")
    }
    console.log(event)
  }
  exportSampleFile(event: any) {
    let col = ['Contact Name', "Contact Phone", "Country Code", "Alt Contact", "Contact Email", "Alt Email", 'Company Name', "Designation", "Sector", "Sub Sector", "Country", "State", "City", "Industry Type", "Lead Type", "Lead Status", "Lead Source", "Additional information", "Deal Size", "Website Link", "Linkedin Link", "Sub Industry", "Initial Requirements", "Currency", "Notes", "Date"];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    console.log(col)
    XLSX.utils.sheet_add_aoa(ws, [col]);
    XLSX.utils.book_append_sheet(wb, ws, 'Sample Lead');

    XLSX.writeFile(
      wb,
      'sample_data.xlsx'
    );

    // ✅ Tracking for sample export
    this.tracker.track(
      "Export",
      "Lead",
      `Sample lead export triggered (${col.length} columns)`
    );
  }
  export(header: any) {

    console.log(header)

    this.exportArrayData = [];
    let param: any = {
      where: { client_id: this.localStorage.getClientId() },
    };

    applyLeadVisibilityToExportPayload(
      param,
      this.localStorage.getUserId(),
      this.isAdmin,
      this.localStorage.getClientId()
    );

    this.isExportLoading = true;



    let exportColumns = header.map((item: any) => {
      return item.value
    });

    const columnMapping = this.exportColumnArrayObject.reduce((map: any, col: any) => {
      map[col.value] = col.key;
      return map;
    }, {});

    console.log("exportColumns", exportColumns);
    // Step 2: Filter and map exportColumns to their corresponding display names
    const selectedColumns = exportColumns.map((key: any) => (
      columnMapping[key] || key // Use mapped key if available
    ));

    const payload: any = {
      "client_id": this.localStorage.getClientId(),
      "headers": selectedColumns
    }

    applyLeadVisibilityToExportPayload(
      payload,
      this.localStorage.getUserId(),
      this.isAdmin,
      this.localStorage.getClientId()
    );

    const dq = this.dateQuery.value;
    if (dq && typeof dq === 'object') {
      if (dq.dynamicFieldDateFilter) {
        payload.dynamicFieldDateFilter = dq.dynamicFieldDateFilter;
      }
      if (dq.startDate && dq.endDate) {
        payload.start_date = dq.startDate;
        payload.end_date = dq.endDate;
      }
    }



    this.api.exportLeadsToS3(payload).subscribe({
      next: (res: any) => {
        this.isExportLoading = false;

        if (res && res.download_url) {
          const link = document.createElement('a');
          link.href = res.download_url;
          link.download = 'leads_export.xlsx'; // optional: use dynamic name if needed
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.toast.success('Leads exported successfully', 'Success!!');

          // ✅ Track export success
          this.tracker.track(
            "Export",
            "Lead",
            `Leads exported successfully. File URL: ${res.download_url}`
          );
        } else {
          this.toast.error('Failed to export leads: No file URL', 'Error!!');
        }
      },
      error: (err: any) => {
        this.isExportLoading = false;
        this.toast.error('Export failed due to server error', 'Error!!');
        console.error('Export error:', err);
      }
    });


  }

  addSubscriberList(isValid: any) {
    this.isSubmitted = true;
    if (isValid) {
      this.btnLoading = true;
      let list_number: any = [];
      let list_email: any = [];
      console.log(this.temp);
      const list = this.temp.reduce((res: any, item: any) => {
        if (item.mobile) {
          list_number.push(item.mobile);
        }
        if (item.email) {
          list_email.push(item.email);
        }
        res.push({
          lead_id: item.lead_id,
          client_id: item.client_id,
          fname: item.fname,
          lname: item.lname,
          name: item.name,
          mobile: item.mobile,
          email: item.email,
        });
        return res;
      }, []);
      let params = {
        subscriber_name: this.subsciberListName,
        client_id: this.localStorage.getClientId(),
        total_subscriber: this.temp.length,
        subscriber_list: list,
        subscriber_phones: list_number,
        subscriber_emails: list_email,
      };
      this.api.addSubcriberList(params).subscribe({
        next: (c) => {
          this.modalService.dismissAll();
          this.temp = [];
          this.reloadData();
          this.btnLoading = false;
          this.isSubmitted = false;
          this.toast.success('Subscriber List Added Successfully', 'Success!!');
          this.tracker.track(
            "Create",
            "Subscriber List",
            `Created subscriber list "${this.subsciberListName}" with ${this.temp.length} leads`
          );

        },
        error: (e) => {
          this.btnLoading = false;
          this.isSubmitted = false;
        },
        complete: () => { },
      });
    }
  }

  isAllSelected() {
    if (!this.dataSource?.data || this.dataSource.data.length === 0) {
      return false;
    }
    return this.dataSource.data.every((item) => !!item.isSelected);
  }

  isAnySelected() {
    if (!this.dataSource?.data || this.dataSource.data.length === 0) {
      return false;
    }
    return this.dataSource.data.some((item) => !!item.isSelected);
  }

  hell(event: any, element: any) {
    const isChecked = event && typeof event.checked === 'boolean'
      ? event.checked
      : !element.isSelected;
    element.isSelected = isChecked;

    if (isChecked) {
      const exists = this.temp.some((obj: any) => String(obj.lead_id) === String(element.lead_id));
      if (!exists) {
        this.temp.push(element);
      }
    } else {
      this.temp = this.temp.filter((obj: any) => String(obj.lead_id) !== String(element.lead_id));
    }
    this.mergedArr = [...this.temp];
    this.cdr.detectChanges();
  }

  selectAll(event: any) {
    const isChecked = !!event?.checked;
    const currentRows = this.dataSource?.data || [];
    currentRows.forEach((item: any) => {
      item.isSelected = isChecked;
    });

    if (!isChecked) {
      const currentIds = new Set(currentRows.map((item: any) => String(item.lead_id)));
      this.temp = this.temp.filter((item: any) => !currentIds.has(String(item.lead_id)));
    } else {
      currentRows.forEach((item: any) => {
        const exists = this.temp.some((obj: any) => String(obj.lead_id) === String(item.lead_id));
        if (!exists) {
          this.temp.push(item);
        }
      });
    }
    this.mergedArr = [...this.temp];
    this.cdr.detectChanges();
  }


  handleOpenCommunicationDialog(content: any, element: any) {

    const commPref = this.localStorage.getCommincationPref();
    console.log("commPref", commPref);

      const isInvalidPref =
        !commPref ||
        typeof commPref !== 'object' ||
        !commPref.email ||
        !commPref.provider;

      if (isInvalidPref) {
        this.modalService.open(this.emailConfirmModal, {
          size: 'md',
          scrollable: true,
          centered: true,
          backdrop: 'static',
          keyboard: false
        });
      } else {
        this.modalService.open(content, {
          size: 'md',
          scrollable: true,
          centered: true,
          backdrop: 'static',
          keyboard: false
        });
      }

    
    this.communicationData = element;
  }

  handleOpenCommunicationLogDialog(content: any, element: any) {
    this.isReminderMode = false; // Reset reminder mode for regular activity log
    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true, backdrop: 'static', keyboard: false
    });
    this.communicationData = element;
  }

  handleOpenReminderActivityLog(content: any, element: any) {
    // Set flag to indicate this is a reminder context
    this.isReminderMode = true;
    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true, backdrop: 'static', keyboard: false
    });
    this.communicationData = element;
  }


  onTableCellClick(event: MouseEvent, it: string, phoneContent: any, emailContent: any, element: any) {
    event.stopPropagation();
    if (it === 'contact_phone') {
      this.onSubmitCall(phoneContent, element);
    } else if (it === 'contact_email') {
      this.onSubmitEmail(emailContent, element);
    }
  }

  onSubmitCall(content: any, element: any) {
    console.log("i am called")
    this.communicationData = element;
    this.btnLoading = false;
    const modalRef = this.modalService.open(content, { size: 'md', scrollable: true, centered: true });
    modalRef.result.finally(() => {
      // Reset styles and ensure dropdown is closed
      document.body.style.overflow = 'auto';
      const dropdowns = document.querySelectorAll('.dropdown-menu.show');
      dropdowns.forEach((dropdown) => dropdown.classList.remove('show'));
    });


  }

  openModel(content: any, element: any) {
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true });
    this.editFieldValues = element;
  }

  openLeadProfile(element: any) {
    const leadId = element?.lead_id;
    if (leadId == null || leadId === '') {
      return;
    }
    const hashPath = this.router.serializeUrl(
      this.router.createUrlTree(['/main/leads', leadId])
    );
    const url = `${window.location.origin}${window.location.pathname}#${hashPath}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    this.current_id_hover = null;
    this.currentMobilePopupLeadId = null;
  }

  onSubmitEmail(content: any, element: any) {

    const commPref = this.localStorage.getCommincationPref();
    console.log("commPref", commPref);

      const isInvalidPref =
        !commPref ||
        typeof commPref !== 'object' ||
        !commPref.email ||
        !commPref.provider;

      if (isInvalidPref) {
        this.modalService.open(this.emailConfirmModal, {
          size: 'md',
          scrollable: true,
          centered: true,
          backdrop: 'static',
          keyboard: false
        });
      } else {
        this.modalService.open(content, {
          size: 'md',
          scrollable: true,
          centered: true,
          backdrop: 'static',
          keyboard: false
        });
      }

    
    this.communicationData = element;
   
  }

  handleShowCanban(event: any) {
    this.kanbanStatus = event;
  }

  getAllPipeline() {
    let param = {
      client_id: this.localStorage.getClientId(),
      pipeline_type: 'lead',
    };
    this.pipelineApi.getAllPipeLine(param).subscribe({
      next: (res: any) => {
        this.pipelineData = res || [];

        this.pipelines = this.pipelineData.map((item: any) => item.pipeline_name);

        if (this.pipelineData.length > 0) {
          this.createFieldFormValue.pipeline_id = this.pipelineData[0].pipeline_id;
          this.getLeadStages(this.pipelineData[0].pipeline_id);
        }

      },
      error: (e: any) => {
        console.error(e);
      },
    });


  }

  determineLeadType(status: string, pipelineId: any): string | null {
    if (!status || !pipelineId || !this.pipelineData) return null;
    const pipe = this.pipelineData.find((p: any) => String(p.pipeline_id) === String(pipelineId));
    if (!pipe || !pipe.stages) return null;
    const stage = pipe.stages.find((s: any) => (s.stage_name || '').trim().toLowerCase() === status.trim().toLowerCase());
    if (!stage || stage.probability == null) return null;
    const prob = Number(stage.probability);
    if (isNaN(prob)) return null;
    if (prob < 30) return 'Cold Lead';
    if (prob < 70) return 'Warm Lead';
    return 'Hot Lead';
  }

  onStatusChangeCreate(): void {
    const status = this.createFieldFormValue['lead_status'];
    const pipelineId = this.createFieldFormValue['pipeline_id'];
    const autoType = this.determineLeadType(status, pipelineId);
    if (autoType) {
      this.createFieldFormValue['lead_type'] = autoType;
    }
  }

  onStatusChangeEdit(): void {
    const status = this.editFieldValues['lead_status'];
    const pipelineId = this.editFieldValues['pipeline_id'];
    const autoType = this.determineLeadType(status, pipelineId);
    if (autoType) {
      this.editFieldValues['lead_type'] = autoType;
    }
  }

  private resolveDefaultLeadStatus(): string {
    const fromPipeline = this.leadStatusList?.find(
      (stage: { value: string }) =>
        String(stage.value).trim().toLowerCase() === 'new'
    );
    return fromPipeline?.value || DEFAULT_LEAD_STATUS;
  }

  getLeadStages(e: any): void {
    const pipelineId = e?.target?.value || e;
    console.log('pipelineId', pipelineId);

    if (!pipelineId || pipelineId == null || pipelineId == undefined) {
      return;
    }

    const filtered = findPipelineById(this.pipelineData, pipelineId);
    if (filtered) {
      this.leadStatusList = (filtered.stages || []).map((stage: any) => {
        return {
          value: stage.stage_name,
          label: pipelineStageLabel(stage)
        }
      });
    }

    // ✅ Set default ONLY after options exist
    if (!this.createFieldFormValue['lead_status']) {
      this.createFieldFormValue['lead_status'] = this.resolveDefaultLeadStatus();
    }
    if (!this.editFieldValues['lead_status']) {
      this.editFieldValues['lead_status'] = this.resolveDefaultLeadStatus();
    }

    // Set default lead type when empty
    if (!this.createFieldFormValue['lead_type'] || String(this.createFieldFormValue['lead_type']).trim() === '') {
      this.createFieldFormValue['lead_type'] = DEFAULT_LEAD_TYPE;
    }
    if (!this.editFieldValues['lead_type'] || String(this.editFieldValues['lead_type']).trim() === '') {
      this.editFieldValues['lead_type'] = DEFAULT_LEAD_TYPE;
    }
  }

  applyLeadBulkFilter(filterData: any) {
    this.isBulkLeadFilter = true;
    this.bulkLeadFilterLoading = true;
    this.bulkLeadFilterData = filterData;
    this.reloadData();
  }

  clearLeadBulkFilter() {
    if (this.isBulkLeadFilter) {
      this.isBulkLeadFilter = false;
      this.bulkLeadFilterLoading = false;
      this.bulkLeadFilterData = null;
      this.reloadData();
    }
  }

  toggleMobileCreatePopup() {
    if (this.isMobileView()) {
      this.mobileCreatePopup = !this.mobileCreatePopup;
    }
  }


  handleConvertToGroup(spaceId: any, content: any, name: any) {
    this.currentSelectedLeadSpaceId = spaceId;
    this.currentSelectedLeadSpaceName = name;
    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (!this.isInfoPopupMobileView()) {
      this.currentMobilePopupLeadId = null;
    }
    if (window.innerWidth > 1024 && this.mobileCreatePopup) {
      this.mobileCreatePopup = false;
      this.leadSpaceToggle = false;
      this.current_id_hover = false;
    }
  }
  toggleMobileInfoLead(leadId: any) {
    if (!this.isInfoPopupMobileView()) {
      return;
    }
    this.currentMobilePopupLeadId =
      this.currentMobilePopupLeadId === leadId ? null : leadId;

    if (this.current_id_hover === leadId) {
      this.current_id_hover = null;
    }
  }

  openConnectEmailModal(content: any) {
    // this.modalService.dismissAll(); // Close any open modals before opening a new one
    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
      backdrop: true,   // default behavior - clicking outside closes modal
      keyboard: true    // allows ESC key to close modal
    });
  }

 resetForm(){
 
   this.clearleadForm();
   this.modalService.dismissAll()
   this.createFieldFormValue = {
    fields: {},
    lead_date: '',
    lead_status:'',
    lead_type:'',
    lead_source:'',
    lead_time: '',
    user_id: '',
    team_id: '',
    isEdit: false
  };
 }



}

export class Lead {
  isSelected = 'isSelected';
  lead_id!: Number;
  fname: string = '';
  lname: string = '';
  leadsfollowup!: JSON;
  prefix: string = '';
  date_of_lead: String = moment().format('YYYY-MM-DD');
  time_of_lead: String = moment().format('HH:mm');
  gender: string = '';
  age: Number = 0;
  email: string = '';
  mobile: string = '';
  state: string = '';
  country: string = '';
  city: string = '';
  address: string = '';
  query: string = '';
  leadStattus: string = '';
  client_id: string = '';
  hospital_id: Number = 0;
  leadChannel: String = '';
}
export class LeadFollowup {
  client_id: string = '';
  center_id: string = '';
  lead_id!: Number;
  user_id!: Number;
  date: string = '';
  time: string = '';
  remarks: string = '';
  notification_date = null;
  next_action: string = '';
  updated_by: any = {
    email: ''
  };
}
